<template>
    <nav class="navbar py-3 border-bottom">
        <div class="container">
            <div class="navbar-brand">
                <img src="/helikoptervlucht-logo.png" alt="Helikopter-vlucht.net" style="height: 50px;" />
            </div>
            <a href="tel:+31591351251" class="text-decoration-none text-secondary">
                <font-awesome-icon icon="fa-solid fa-phone" class="me-2" />
                <span class="d-none d-md-inline">0591 351 251</span>
            </a>
        </div>
    </nav>
</template>
